import React from 'react';
import './StatTile.scss';

export type StatTileTone = 'success' | 'warning' | 'danger';

interface StatTileProps {
  label: React.ReactNode;
  value: React.ReactNode;
  /** Small unit after the value, e.g. "min". */
  unit?: React.ReactNode;
  /** Explanation shown on hover over the label. */
  hint?: string;
  /** Colours the value when it carries a judgement (e.g. a rate against a target). */
  tone?: StatTileTone;
}

/** KPI tile: uppercase label over a large tabular number. Candidate for src/ui. */
const StatTile: React.FC<StatTileProps> = ({ label, value, unit, hint, tone }) => (
  <div className="tel-stat">
    <div className="tel-stat__label" title={hint}>{label}</div>
    <div className={tone ? `tel-stat__value tel-stat__value--${tone}` : 'tel-stat__value'}>
      {value}
      {unit ? <span className="tel-stat__unit">{unit}</span> : null}
    </div>
  </div>
);

export default StatTile;
